import styled from "styled-components";
import { useTranslation } from 'react-i18next';



export const NoInternet = () => {
const { t } = useTranslation();

return (
  <Container>
    <Icon>
      <svg width="93" height="78" viewBox="0 0 93 78" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="927xk0l6ia">
            <stop stop-color="#CF9B5E" offset="0%"/>
            <stop stop-color="#EFE090" offset="49.931%"/>
            <stop stop-color="#CF9B5E" offset="100%"/>
          </linearGradient>
        </defs>
        <path d="m219.29 0 71.35 71.482-5.866 5.958c-.224-.269-.456-.595-.734-.875-9.368-9.392-18.75-18.77-28.09-28.189-.687-.692-1.351-.895-2.256-.828-7.233.54-13.522 3.222-18.796 8.24-.14.133-.292.253-.418.363l-8.385-8.459c5.131-5.1 11.261-8.637 18.43-10.644-.293-.325-.492-.566-.711-.786-2.609-2.619-5.242-5.213-7.815-7.865-.62-.64-1.091-.767-1.937-.391a54.527 54.527 0 0 0-15.694 10.513l-.607.579-8.411-8.443c4.798-4.789 10.44-8.786 16.642-11.934l-12.69-12.714L219.291 0zm23.718 64.653c6.4-6.802 18.232-7.137 25.02-.05l-12.52 12.57-12.5-12.52zm26.96-26.5c5.682 2.096 10.714 5.27 15.048 9.581l-1.88 1.882-.867.869-12.301-12.333zm-25.77-25.603c22.269-3.187 41.446 2.747 57.61 18.077l-8.423 8.464c-1.4-1.211-2.866-2.584-4.437-3.825-9.697-7.663-20.756-11.493-33.085-11.73-.416-.009-.946-.136-1.224-.41-3.406-3.357-6.775-6.751-10.151-10.138-.066-.066-.105-.157-.29-.438z" transform="translate(-209)" fill="url(#927xk0l6ia)" fill-rule="nonzero"/>
      </svg>
    </Icon>
    <Heading>{t('No Internet Connection')}</Heading>
    <Text>{t('Make sure Wi-Fi or Cellular Data is turned on, then try again.')}</Text>
    <Button>
      <ButtonText>{t('RETRY')}</ButtonText></Button>
  </Container>
);
}

const Container = styled.div`
  width: 100%;
  height: 100svh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: radial-gradient(circle 70vw at center, rgba(126, 72, 30, 0.3), rgba(0, 0, 0, 0) 90%);
`;

const Icon = styled.div`
  margin-bottom: 15px;
`

const Heading = styled.h2`
  font-size: 30px;
  font-family: Teko;
  font-weight: 500;
  color: #fff;
  margin: 0;
`

const Text = styled.p`
  font-size: 20px;
  font-family: Teko;
  color: #fff;
  margin: 0;
`

const Button = styled.button`
  width: 160px;
  height: 40px;
  margin: 14px 176px 0;
  padding: 8.4px 39px 7.6px;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 3px 10px 0 rgba(255, 155, 0, 0.55), 0 2px 0 0 #985b09, inset 0 1px 0 0 #fff;
  border: solid 1.5px #ffe893;
  background-image: linear-gradient(to bottom, #cf9b5e 0%, #fff8d3 51%, #cf9b5e 100%);
  cursor: pointer;
`


const ButtonText = styled.span`
  background-image: linear-gradient(to bottom, #000 0%, rgba(87, 84, 84, 0.82) 18%, #000 50%);
  font-family: Teko;
  font-size: 18px;
  font-weight: bold;
  line-height: 1.04;
  letter-spacing: 0.98px;
  text-align: center;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
`;
